import styles from "./Navigation.module.css"
import { useState } from "react"
import { InformationCircleIcon } from "@heroicons/react/20/solid";
import { Archive, Clock, ClockOutline, Folder, InformationCircle, InformationCircleOutline } from "heroicons-react";
import { FilePosition } from "postcss";
import Programs from "../programs/Programs";
import { ListBulletIcon } from "@heroicons/react/24/outline";
interface Props {
  nav: string | any
}
function Navigation(props: Props) {
  const [page, setPage] = useState("info")
  function onChangeHandler(value: string) {
    setPage(value)
    props.nav(value)
  }
  return (
    <div className={styles.nav}>
      <div className={styles.item + " " + (page === "info" ? styles.active : null)} onClick={() => onChangeHandler("info")}>
        <InformationCircleOutline className={styles.icon}></InformationCircleOutline>
        Info
      </div>
      <div className={styles.item + " " + (page === "logs" ? styles.active : null)} onClick={() => onChangeHandler("logs")}>
        {/*<Folder className={styles.icon}></Folder> Logs*/}
        <ClockOutline className={styles.icon}></ClockOutline> History
      </div>
      <div className={styles.item + " " + (page === "programs" ? styles.active : null)} onClick={() => onChangeHandler("programs")}>
        <ListBulletIcon className={styles.icon}></ListBulletIcon> Programs
      </div>
    </div>
  )
}

export default Navigation
